<template>
    <div class="row">
        <div class="col-sm-8 col-w" id="termometria">
            <div class="card h-100 mb-0">
                <div class="card-header">
                    <div class="row">
                        <div class="d-flex" style="justify-content: space-between;">
                            <h4 class="title-relatorio">Termometria</h4>
                            <button :class="['btn', textoBotao == 'Leitura disparada!' ? 'btn-dark' : 'btn-success']" type="button" @click="disparaLeitura(this.silo.id)" :disabled="loading || bloqueioLeituraDisparada">
                                {{ textoBotao }}
                            </button>
                        </div>
                    </div>

                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <button :class="['nav-link', 'button-component', { active: tabTermometria }]" @click="activateTabTermometria(true)" style="border-radius: 10px 10px 0px 0px !important;">Termometria</button>
                        </li>
                        <li class="nav-item">
                            <button :class="['nav-link', 'button-component', { active: !tabTermometria }]" @click="activateTabTermometria(false)" style="border-radius: 10px 10px 0px 0px !important;">Silo 3D</button>
                        </li>
                    </ul>
                </div>
                <div class="card-body content-leituras">
                    <div class="tab-content">
                        <div :class="['container', 'container-programa', 'tab-pane', { active: tabTermometria }]" v-if="tabTermometria">
                            <SelectLeituras :leituras="leituras" @changeLeitura="leituraChangeSelect"/>
                            <ViewLeitura :termometria="termometria"/>
                        </div>
                        <div :class="['container', 'container-programa', 'tab-pane', { active: !tabTermometria }]" v-else>
                            <Silo3dComponent :silo="silo" :termometria="termometria"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4  col-w">
            <InformacoesGeraisBySilo :silo="silo" />
        </div>
        <AeracaoContent v-if="silo.existe_aeracao" :aeracao="silo.aeracao" :programa="silo.programa" :modoOperacao="silo.modo_operacao"/>
    </div>
</template>
<script>
import SelectLeituras from './Termometria/SelectLeituras.vue';
import ViewLeitura from './Termometria/ViewLeitura.vue';
import InformacoesGeraisBySilo from './Termometria/InformacoesGeraisBySilo.vue';
import AeracaoContent from './Termometria/AeracaoContent.vue';
import Silo3dComponent from './Termometria/Silo3dComponent.vue';

import { ref, watch } from "vue";
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';

export default {
    props: {
        silo: Object,
        leituras: Array,
        termometria: Object
    },
    components: {
        SelectLeituras,
        ViewLeitura,
        InformacoesGeraisBySilo,
        AeracaoContent,
        Silo3dComponent
    },
    setup(props) {
        const tabTermometria = ref(true);
        const loading = ref(false);
        const textoBotao = ref('Iniciar nova Leitura');
        const bloqueioLeituraDisparada = ref(false);
        const store = useStore();
        const toast = useToast();

        const disparaLeitura = async ($siloId) => {
            try{
                loading.value = true;
                textoBotao.value = 'Disparando...';
                const response = await store.dispatch('silo/disparaLeitura', $siloId);
                toast.info("Disparo enviado ao Painel TermoWeb, aguardando confirmação...", { timeout: 3900 });
                let messageId = response.data.message.message_id;
                setTimeout(async () => {
                    let msg = await store.dispatch("message/fetchMessage", messageId);
                    if (msg.status !== 'processed') {
                        toast.error("Disparo de leitura não processado pelo Painel TermoWeb.");
                        loading.value = false;
                        textoBotao.value = 'Iniciar nova Leitura';
                        bloqueioLeituraDisparada.value = false;
                        loading.value = false;
                    } else {
                        toast.success("Disparo enviado ao silo.");
                        loading.value = false;
                        textoBotao.value = 'Leitura disparada!';
                        bloqueioLeituraDisparada.value = true;
                        loading.value = false;
                    }
                }, 4000);
            } catch (error) {
                loading.value = false;
                textoBotao.value = 'Iniciar nova Leitura';
                bloqueioLeituraDisparada.value = false;
                toast.error('Erro ao disparar leitura');
            }
        }

        watch(() => props.silo, () => {
            loading.value = false;
            textoBotao.value = 'Iniciar nova Leitura';
            bloqueioLeituraDisparada.value = false;
        });

        return {
            tabTermometria,
            activateTabTermometria: (action) => tabTermometria.value = action,
            disparaLeitura,
            loading,
            textoBotao,
            bloqueioLeituraDisparada
        }
    },
    methods: {
        leituraChangeSelect(value) {
            this.$emit('selectedLeitura', value);
        }
    }
}
</script>